import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { IActionErrorInfo } from "../../jobs/types/IActionErrorInfo";
import { getTicketGridList } from "../thunks/getTicketGridList";
import { ITicketGridsState } from "../types/ITicketGridsState";

export const addGetTicketGridList = (
  builder: ActionReducerMapBuilder<ITicketGridsState>,
) => {
  builder.addCase(getTicketGridList.pending, (state) => {
    state.loadingReports = true;
  });
  builder.addCase(getTicketGridList.rejected, (state, action) => {
    state.loadingReports = false;
    if (
      action.error.message !== "Aborted" &&
      action.error.name !== "TypeError"
    ) {
      const error: IActionErrorInfo = {
        id: Date.now(),
        message: `Не удалось получить список билетных сеток!: ${action.error.message}`,
      };
      state.errors = [...state.errors, error];
    }
  });
  builder.addCase(getTicketGridList.fulfilled, (state, action) => {
    state.loadingReports = false;
    state.templates = [...action.payload];
  });
};
